(() => {
  const root = document.querySelector('[data-lpq]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  let DATA = {};
  let ANY_AVAILABLE = false;
  try { DATA = JSON.parse((document.querySelector('[data-lpq-products]')?.textContent || '{}').replace(/,(\s*[}\]])/g, '$1')); } catch (e) { DATA = {}; }
  ANY_AVAILABLE = Object.values(DATA).some((d) => d && d.available);

  const PET_ICONS = {
    guinea: '<svg viewBox="0 0 48 48"><path d="M8 30c0-9 8-15 17-15 9 0 15 6 15 13 0 6-5 9-12 9H16c-5 0-8-3-8-7z"/><circle cx="33" cy="25" r="1.6" fill="currentColor" stroke="none"/><path d="M36 17c1-3 4-4 6-2M40 29h4M14 37v3M30 37v3"/></svg>',
    rabbit: '<svg viewBox="0 0 48 48"><path d="M19 20c-2-8-1-15 2-15s4 7 3 14M27 19c0-8 2-14 5-14s3 7 0 15"/><path d="M12 33c0-8 6-13 13-13s12 5 12 12c0 6-5 10-12 10s-13-3-13-9z"/><circle cx="21" cy="29" r="1.5" fill="currentColor" stroke="none"/><circle cx="29" cy="29" r="1.5" fill="currentColor" stroke="none"/><path d="M23 34l2 1.5 2-1.5"/></svg>',
    dog: '<svg viewBox="0 0 48 48"><path d="M14 14l-6 4 2 10 5-3M34 14l6 4-2 10-5-3"/><path d="M14 14c3-3 7-4 10-4s7 1 10 4c2 4 2 10 0 15-2 6-6 9-10 9s-8-3-10-9c-2-5-2-11 0-15z"/><circle cx="19" cy="23" r="1.5" fill="currentColor" stroke="none"/><circle cx="29" cy="23" r="1.5" fill="currentColor" stroke="none"/><path d="M21 31c1.5 1.5 4.5 1.5 6 0M24 28v3"/></svg>',
    cat: '<svg viewBox="0 0 48 48"><path d="M11 9l4 12M37 9l-4 12M11 9l9 7h8l9-7"/><path d="M11 21c0 10 6 17 13 17s13-7 13-17"/><circle cx="19" cy="26" r="1.5" fill="currentColor" stroke="none"/><circle cx="29" cy="26" r="1.5" fill="currentColor" stroke="none"/><path d="M22 31l2 1.5 2-1.5M7 29l8-1M7 34l8-3M41 29l-8-1M41 34l-8-3"/></svg>',
    other: '<svg viewBox="0 0 48 48"><circle cx="15" cy="20" r="3.5"/><circle cx="21" cy="12" r="3.5"/><circle cx="29" cy="12" r="3.5"/><circle cx="35" cy="20" r="3.5"/><path d="M24 40c-6 0-10-3-10-7s4-6 6-8.5c1-1.4 2.3-2.5 4-2.5s3 1.1 4 2.5c2 2.5 6 4.5 6 8.5s-4 7-10 7z"/></svg>'
  };
  const ICON = {
    bed: '<svg viewBox="0 0 24 24"><path d="M3 18v-7h18v7M3 14h18M6 11V8h5v3"/></svg>',
    drop: '<svg viewBox="0 0 24 24"><path d="M12 3c3 4 6 7 6 11a6 6 0 0 1-12 0c0-4 3-7 6-11z"/></svg>',
    sparkle: '<svg viewBox="0 0 24 24"><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M18 6l-2.5 2.5M8.5 15.5L6 18"/></svg>',
    toy: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><path d="M12 4c-2 3-2 13 0 16M4.5 9.5c4 1.5 11 1.5 15 0"/></svg>',
    heart: '<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>',
    help: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6V14M12 17v.5"/></svg>',
    clock: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    ruler: '<svg viewBox="0 0 24 24"><path d="M3 15l12-12 6 6-12 12zM7 11l2 2M10 8l2 2M13 5l2 2"/></svg>',
    cage: '<svg viewBox="0 0 24 24"><path d="M4 6h16v14H4zM8 6v14M12 6v14M16 6v14M4 4h16"/></svg>',
    grid: '<svg viewBox="0 0 24 24"><path d="M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z"/></svg>',
    custom: '<svg viewBox="0 0 24 24"><path d="M4 20V8l8-4 8 4v12zM9 20v-6h6v6"/></svg>',
    floor: '<svg viewBox="0 0 24 24"><path d="M3 17l9-5 9 5-9 5zM3 12l9-5 9 5"/></svg>',
    shield: '<svg viewBox="0 0 24 24"><path d="M12 3l7 3v5.5c0 4.4-3 7.8-7 9.5-4-1.7-7-5.1-7-9.5V6z"/></svg>',
    tag: '<svg viewBox="0 0 24 24"><path d="M3 12V4h8l10 10-8 8zM7.5 7.5h.01"/></svg>',
    box: '<svg viewBox="0 0 24 24"><path d="M3 7l9-4 9 4v10l-9 4-9-4zM3 7l9 4 9-4M12 11v10"/></svg>',
    one: '<svg viewBox="0 0 24 24"><rect x="6" y="6" width="12" height="12" rx="2"/></svg>',
    star: '<svg viewBox="0 0 24 24"><path d="M12 3l2.7 5.6 6.1.8-4.5 4.2 1.1 6.1L12 16.9 6.6 19.7l1.1-6.1L3.2 9.4l6.1-.8z"/></svg>',
    s: '<svg viewBox="0 0 24 24"><rect x="8" y="8" width="8" height="8"/></svg>',
    m: '<svg viewBox="0 0 24 24"><rect x="6" y="6" width="12" height="12"/></svg>',
    l: '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18"/></svg>'
  };

  const STEPS = [
    { id: 'pets', multi: true, title: 'What kind of pet do you have?', hint: 'Choose all that apply.', options: [
      { v: 'guinea', label: 'Guinea pig', pet: true }, { v: 'rabbit', label: 'Rabbit', pet: true }, { v: 'dog', label: 'Dog', pet: true },
      { v: 'cat', label: 'Cat', pet: true }, { v: 'other', label: 'Other', pet: true } ] },
    { id: 'shop', title: 'What are you shopping for?', options: [
      { v: 'bedding', label: 'Comfortable cage bedding', icon: 'bed' }, { v: 'waterproof', label: 'Waterproof protection', icon: 'drop' },
      { v: 'cleaning', label: 'Easy-to-clean liners', icon: 'sparkle' }, { v: 'enrichment', label: 'Toys and enrichment', icon: 'toy' },
      { v: 'comfort', label: 'Soft blankets and resting areas', icon: 'heart' }, { v: 'unsure', label: 'Not sure — help me choose', icon: 'help' } ] },
    { id: 'challenge', title: "What's your biggest challenge?", options: [
      { v: 'cleaning', label: 'Keeping the cage clean', icon: 'sparkle' }, { v: 'waterproof', label: 'Dealing with leaks and moisture', icon: 'drop' },
      { v: 'time', label: 'Spending too much time cleaning', icon: 'clock' }, { v: 'enrichment', label: 'Keeping my pet entertained', icon: 'toy' },
      { v: 'comfort', label: "Making my pet's space more comfortable", icon: 'heart' }, { v: 'fit', label: 'Finding the right product or size', icon: 'ruler' } ] },
    { id: 'space', title: 'Where will you use the product?', skip: (a) => skipSpace(a), options: [
      { v: 'midwest', label: 'Midwest cage', icon: 'cage' }, { v: 'cc', label: 'C&C cage', icon: 'grid' },
      { v: 'custom', label: 'Custom cage or enclosure', icon: 'custom' }, { v: 'floor', label: 'Open floor or play area', icon: 'floor' },
      { v: 'bed', label: 'Pet bed or resting area', icon: 'bed' }, { v: 'unsure', label: 'Other / Not sure', icon: 'help' } ] },
    { id: 'size', title: "What size is your pet's space?", skip: (a) => skipSpace(a) || ['bed', 'floor'].includes(a.space), options: [
      { v: 'small', label: 'Small', icon: 's' }, { v: 'medium', label: 'Medium', icon: 'm' }, { v: 'large', label: 'Large', icon: 'l' },
      { v: 'custom', label: 'Custom size', icon: 'ruler' }, { v: 'unsure', label: 'Not sure', icon: 'help' } ] },
    { id: 'priority', title: "What's most important to you?", options: [
      { v: 'cleaning', label: 'Easy cleaning', icon: 'sparkle' }, { v: 'waterproof', label: 'Waterproof protection', icon: 'drop' },
      { v: 'comfort', label: 'Softness and comfort', icon: 'heart' }, { v: 'durable', label: 'Durability', icon: 'shield' },
      { v: 'cheap', label: 'Affordable price', icon: 'tag' }, { v: 'enrichment', label: 'Fun and enrichment', icon: 'toy' } ] },
    { id: 'solution', title: 'What type of solution would you prefer?', options: [
      { v: 'single', label: 'A single essential product', icon: 'one' }, { v: 'bundle', label: 'A complete set or bundle', icon: 'box' },
      { v: 'cheap', label: 'The most affordable option', icon: 'tag' }, { v: 'best', label: 'The best overall recommendation', icon: 'star' },
      { v: 'unsure', label: 'Not sure', icon: 'help' } ] }
  ];

  const CAGE = ['guinea', 'rabbit', 'other'];
  const skipSpace = (a) => a.shop === 'enrichment' || !(a.pets || []).some((p) => CAGE.includes(p));

  const P = {
    'guinea-pig-cage-liner-bedding-system': { name: 'Complete Cage Bedding System', pets: ['guinea', 'rabbit', 'other'], needs: ['bedding', 'waterproof', 'cleaning', 'comfort', 'time'], spaces: ['midwest', 'cc'], kind: 'bundle', tier: 3, durable: 2,
      why: { bedding: 'A complete bedding setup in one box, nothing to piece together', waterproof: 'The waterproof EVA base keeps the floor dry', cleaning: 'Hay shakes right off the fast-dry liner', time: 'Cleaning takes minutes, not an hour', comfort: 'A soft fleece top layer for comfortable paws' } },
    'guinea-pig-fleece-bedding-rabbit': { name: '5-Piece Fleece Liner Set', pets: ['guinea', 'rabbit', 'other'], needs: ['bedding', 'cleaning', 'comfort', 'time'], spaces: ['midwest', 'cc'], kind: 'set', tier: 2, durable: 1,
      why: { bedding: 'Five pieces cover the whole cage floor', cleaning: 'Machine washable, so you never buy bedding again', time: 'Swap a liner and wash it, done in minutes', comfort: 'Soft fleece that stays dry on top' } },
    'fleece-bedding-for-guinea-pigs-midwest': { name: 'Fleece Cage Liner Starter Kit', pets: ['guinea', 'rabbit', 'other'], needs: ['bedding', 'cleaning'], spaces: ['midwest'], kind: 'single', tier: 1, durable: 0,
      why: { bedding: 'An easy way to start with washable bedding', cleaning: 'Washable fleece, no more loose litter' } },
    'eva-rabbit-guinea-pig-cage-liner': { name: 'Cut-to-Fit Waterproof Liner', pets: ['guinea', 'rabbit', 'other', 'dog', 'cat'], needs: ['waterproof', 'fit'], spaces: ['custom', 'floor', 'unsure', 'cc', 'midwest'], kind: 'single', tier: 1, durable: 2, sizes: ['custom', 'large'],
      why: { waterproof: 'A waterproof layer that stops leaks reaching the floor', fit: 'Cut it to fit any cage, pen or play area' } },
    'plush-rabbit-bed': { name: 'Ultra-Soft Fleece Blanket', pets: ['rabbit', 'guinea', 'other', 'cat', 'dog'], needs: ['comfort'], spaces: ['bed', 'floor'], kind: 'single', tier: 1, durable: 0,
      why: { comfort: 'An ultra-soft spot to rest and snuggle' } },
    'sunflower-snuffle-mat-for-rabbits-and-dogs': { name: 'Sunflowerz Snuffle Mat', pets: ['rabbit', 'guinea', 'dog', 'cat', 'other'], needs: ['enrichment'], spaces: ['floor'], kind: 'single', tier: 2, durable: 1, best: true,
      why: { enrichment: 'Hide treats in the petals for natural foraging fun' } },
    'carrot-snuffle-toy-for-rabbits-and-dogs': { name: 'Carrot Sniff Toy', pets: ['rabbit', 'guinea', 'other', 'dog', 'cat'], needs: ['enrichment'], spaces: ['floor'], kind: 'single', tier: 1, durable: 0,
      why: { enrichment: 'A small sniff toy that keeps curious noses busy' } },
    'snuffle-bundle-rabbit': { name: 'Sunflowerz Mat + Carrot Sniff Toy Bundle', pets: ['rabbit', 'dog', 'cat', 'guinea', 'other'], needs: ['enrichment'], spaces: ['floor'], kind: 'bundle', tier: 2, durable: 1,
      why: { enrichment: 'Two enrichment activities in one bundle, for longer play' } },
    'bone-snuffle-mat-for-dogs': { name: 'Squeaky Bone Snuffle Mat', pets: ['dog'], needs: ['enrichment'], spaces: ['floor'], kind: 'single', tier: 2, durable: 1,
      why: { enrichment: 'A squeaky foraging mat made for dogs' } },
    'pupios-pasta-snuffle-toy-for-dogs': { name: "Pupio's Pasta Snuffle Toy", pets: ['dog'], needs: ['enrichment'], spaces: ['floor'], kind: 'single', tier: 1, durable: 0,
      why: { enrichment: 'A crinkly puzzle that slows down treat time' } },
    'rabbit-snuffle-mat-and-sniff-toy-for-dogs': { name: 'Snuffle Tweetz', pets: ['dog', 'rabbit'], needs: ['enrichment'], spaces: ['floor'], kind: 'single', tier: 1, durable: 0,
      why: { enrichment: 'A sniff toy and mat to keep your pet busy' } }
  };

  const PET_NAME = { guinea: 'guinea pig', rabbit: 'rabbit', dog: 'dog', cat: 'cat', other: 'pet' };
  const NEED_OF = { shop: { bedding: 'bedding', waterproof: 'waterproof', cleaning: 'cleaning', enrichment: 'enrichment', comfort: 'comfort' },
    challenge: { cleaning: 'cleaning', waterproof: 'waterproof', time: 'time', enrichment: 'enrichment', comfort: 'comfort', fit: 'fit' },
    priority: { cleaning: 'cleaning', waterproof: 'waterproof', comfort: 'comfort', enrichment: 'enrichment' } };

  const body = root.querySelector('[data-lpq-body]');
  const bar = root.querySelector('[data-lpq-bar]');
  const back = root.querySelector('[data-lpq-back]');
  const dialog = root.querySelector('[role="dialog"]');
  let answers = {};
  let history = [];
  let index = 0;
  let lastFocus = null;

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const visibleSteps = () => STEPS.filter((s) => !(s.skip && s.skip(answers)));

  const needsFromAnswers = () => {
    const w = {};
    const add = (n, x) => { if (n) w[n] = (w[n] || 0) + x; };
    add(NEED_OF.shop[answers.shop], 5);
    add(NEED_OF.challenge[answers.challenge], 3);
    add(NEED_OF.priority[answers.priority], 3);
    return w;
  };

  const score = (handle, pets) => {
    const p = P[handle];
    const d = DATA[handle];
    if (!p || (!d && Object.keys(DATA).length) || (d && !d.available && ANY_AVAILABLE)) return -1;
    const petHits = pets.filter((x) => p.pets.includes(x)).length;
    const w = needsFromAnswers();
    let s = 100 + petHits * 2;
    if (!petHits) s -= 30;
    if (!d) s -= 20;
    else if (!d.available) s -= 40;
    let needHit = 0;
    for (const [n, v] of Object.entries(w)) if (p.needs.includes(n)) { s += v; needHit += v; }
    if (Object.keys(w).length && !needHit) s -= 4;
    if (answers.space && p.spaces.includes(answers.space)) s += 2;
    if (answers.size && p.sizes && p.sizes.includes(answers.size)) s += 2;
    if (['large', 'medium'].includes(answers.size) && p.kind !== 'single') s += 1;
    if (answers.priority === 'durable') s += p.durable;
    if (answers.priority === 'cheap' || answers.solution === 'cheap') s += (3 - p.tier) * 1.5;
    if (answers.solution === 'bundle' && p.kind !== 'single') s += 3;
    if (answers.solution === 'single' && p.kind === 'single') s += 2;
    if (answers.solution === 'best' && (p.kind === 'bundle' || p.best)) s += 2;
    if (p.pets[0] === pets[0]) s += 0.5;
    return s;
  };

  const rank = (pets, exclude = []) => Object.keys(P)
    .filter((h) => !exclude.includes(h))
    .map((h) => [h, score(h, pets)])
    .filter(([, s]) => s >= 0)
    .sort((a, b) => b[1] - a[1])
    .map(([h]) => h);

  const reasons = (handle, pets) => {
    const p = P[handle];
    const out = [];
    const w = needsFromAnswers();
    Object.keys(w).sort((a, b) => w[b] - w[a]).forEach((n) => { if (p.why[n] && !out.includes(p.why[n])) out.push(p.why[n]); });
    Object.values(p.why).forEach((t) => { if (out.length < 2 && !out.includes(t)) out.push(t); });
    const forPets = pets.filter((x) => p.pets.includes(x)).map((x) => PET_NAME[x]);
    if (forPets.length) out.push(`Made for your ${[...new Set(forPets)].join(' and ')}`);
    if (answers.space === 'midwest' && p.spaces.includes('midwest')) out.push('Sized for a Midwest cage');
    if (answers.space === 'cc' && p.spaces.includes('cc')) out.push('Fits a C&C 2x4 cage');
    if (answers.solution === 'bundle' && p.kind !== 'single') out.push('A complete set, so nothing else to buy');
    if ((answers.priority === 'cheap' || answers.solution === 'cheap') && p.tier === 1) out.push('One of our most affordable picks');
    return out.slice(0, 4);
  };

  const pickVariant = (handle) => {
    const d = DATA[handle];
    const vs = (d?.variants || []).filter((v) => v.available);
    if (!vs.length) return null;
    if (answers.space === 'cc') return vs.find((v) => /c&c|2x4/i.test(v.title)) || vs[0];
    if (answers.space === 'midwest') return vs.find((v) => /midwest/i.test(v.title)) || vs[0];
    return vs[0];
  };

  const setProgress = () => {
    const steps = visibleSteps();
    const done = index >= steps.length ? 1 : index / steps.length;
    bar.style.width = `${Math.max(4, Math.round(done * 100))}%`;
    back.hidden = index === 0 || index > steps.length;
  };

  const transition = (html, dir = 1) => {
    body.classList.remove('is-in-fwd', 'is-in-back');
    body.innerHTML = html;
    void body.offsetWidth;
    body.classList.add(dir > 0 ? 'is-in-fwd' : 'is-in-back');
    const first = body.querySelector('[data-lpq-focus]') || body.querySelector('button, a, select');
    first?.focus({ preventScroll: true });
  };

  const renderStep = (dir = 1) => {
    const steps = visibleSteps();
    if (index >= steps.length) return renderResult();
    const step = steps[index];
    const current = answers[step.id];
    const opts = step.options.map((o) => {
      const on = step.multi ? (current || []).includes(o.v) : current === o.v;
      const icon = o.pet ? PET_ICONS[o.v] : ICON[o.icon] || '';
      return `<button type="button" class="lpq__opt${o.pet ? ' lpq__opt--pet' : ''}${on ? ' is-on' : ''}" data-lpq-opt="${o.v}" aria-pressed="${on}">
        <span class="lpq__ico" aria-hidden="true">${icon}</span><span class="lpq__lbl">${esc(o.label)}</span>
        <span class="lpq__tick" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span></button>`;
    }).join('');
    transition(`<div class="lpq__step">
      <p class="lpq__count">Question ${index + 1} of ${steps.length}</p>
      <h2 class="lpq__q" id="LpqTitle" tabindex="-1" data-lpq-focus>${esc(step.title)}</h2>
      ${step.hint ? `<p class="lpq__hint">${esc(step.hint)}</p>` : ''}
      <div class="lpq__opts${step.multi ? ' lpq__opts--pets' : ''}">${opts}</div>
      ${step.multi ? `<button type="button" class="lpq__next" data-lpq-next ${current && current.length ? '' : 'disabled'}>Continue</button>` : ''}
    </div>`, dir);
    setProgress();
  };

  const productCard = (handle, role, pets) => {
    const p = P[handle];
    const d = DATA[handle] || { url: `/products/${handle}`, img: '', price: '', compare: '', variants: [] };
    const v = pickVariant(handle);
    const multi = (d.variants || []).filter((x) => x.available).length > 1;
    const select = multi ? `<select class="lpq__sel" data-lpq-variant aria-label="Choose an option for ${esc(p.name)}">${d.variants.filter((x) => x.available).map((x) => `<option value="${x.id}"${v && x.id === v.id ? ' selected' : ''}>${esc(x.title)}</option>`).join('')}</select>` : `<input type="hidden" data-lpq-variant value="${v ? v.id : ''}">`;
    const img = d.img ? `<img src="${d.img}" alt="${esc(p.name)}" loading="lazy">` : '';
    const add = (cls, label) => (v ? `<button type="button" class="${cls}" data-lpq-add>${label}</button>` : `<a class="${cls}" href="${d.url}">View product</a>`);
    if (role === 'best') {
      const why = reasons(handle, pets).map((r) => `<li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>${esc(r)}</li>`).join('');
      return `<article class="lpq__best">
        <a class="lpq__best-img" href="${d.url}">${img}</a>
        <div class="lpq__best-body">
          <p class="lpq__badge"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l2.7 5.6 6.1.8-4.5 4.2 1.1 6.1L12 16.9 6.6 19.7l1.1-6.1L3.2 9.4l6.1-.8z"/></svg>Best match</p>
          <h3>${esc(p.name)}</h3>
          <p class="lpq__price">${d.compare ? `<del>${d.compare}</del>` : ''}${d.price}</p>
          <p class="lpq__why-title">Why it's right for your pet</p>
          <ul class="lpq__why">${why}</ul>
          <div class="lpq__buy">${v ? select : ''}${add('lp-btn lpq__add', 'Add to cart')}</div>
          ${v ? `<a class="lpq__link" href="${d.url}">View product</a>` : ''}
        </div>
      </article>`;
    }
    return `<article class="lpq__alt">
      <a class="lpq__alt-img" href="${d.url}">${img}</a>
      <div class="lpq__alt-body">
        ${role ? `<p class="lpq__alt-role">${esc(role)}</p>` : ''}
        <a class="lpq__alt-name" href="${d.url}">${esc(p.name)}</a>
        <p class="lpq__price lpq__price--sm">${d.compare ? `<del>${d.compare}</del>` : ''}${d.price}</p>
        <div class="lpq__buy lpq__buy--sm">${v ? select : ''}${add('lpq__add-sm', 'Add')}</div>
      </div>
    </article>`;
  };

  const renderResult = () => {
    const pets = answers.pets && answers.pets.length ? answers.pets : ['other'];
    const ranked = rank(pets);
    const best = ranked[0];
    const used = [best];
    const extras = [];
    pets.forEach((pet) => {
      if (P[best].pets.includes(pet) || extras.some((e) => P[e.handle].pets.includes(pet))) return;
      const pick = rank([pet], used).find((h) => P[h].pets.includes(pet));
      if (pick) { extras.push({ handle: pick, pet }); used.push(pick); }
    });
    const alts = ranked.filter((h) => !used.includes(h)).slice(0, Math.max(0, 2 - extras.length));
    const petList = [...new Set(pets.map((p) => PET_NAME[p]))];
    const others = [
      ...extras.map((e) => productCard(e.handle, `For your ${PET_NAME[e.pet]}`, pets)),
      ...alts.map((h) => productCard(h, 'Also great', pets))
    ].join('');
    transition(`<div class="lpq__result">
      <p class="lpq__count">Your match is ready</p>
      <h2 class="lpq__q" id="LpqTitle" tabindex="-1" data-lpq-focus>Here's what we'd pick for your ${esc(petList.join(' & '))}.</h2>
      ${productCard(best, 'best', pets)}
      ${others ? `<p class="lpq__alts-title">${extras.length ? 'Something for everyone at home' : 'Alternative products'}</p><div class="lpq__alts">${others}</div>` : ''}
      <div class="lpq__end"><button type="button" class="lpq__restart" data-lpq-restart>Start again</button><a href="/collections/all">Shop all products</a></div>
    </div>`);
    bar.style.width = '100%';
    back.hidden = false;
  };

  const open = (event) => {
    event?.preventDefault();
    lastFocus = document.activeElement;
    answers = {};
    history = [];
    index = 0;
    root.hidden = false;
    document.documentElement.classList.add('lpq-lock');
    requestAnimationFrame(() => root.classList.add('is-open'));
    renderStep();
  };
  const close = () => {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('lpq-lock');
    setTimeout(() => { root.hidden = true; }, 250);
    lastFocus?.focus?.();
  };

  const addToCart = async (btn) => {
    const wrap = btn.closest('.lpq__buy');
    const id = Number(wrap.querySelector('[data-lpq-variant]').value);
    if (!id) return;
    const label = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    const drawer = document.querySelector('cart-drawer');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: drawer ? ['cart-drawer', 'cart-icon-bubble'] : [], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Could not add to cart');
      btn.textContent = 'Added';
      btn.classList.add('is-added');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        setTimeout(() => {
          close();
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id, sections: data.sections });
        }, 500);
      } else {
        setTimeout(() => { window.location.href = '/cart'; }, 500);
      }
    } catch (e) {
      btn.textContent = 'Try again';
      btn.disabled = false;
    } finally {
      btn.classList.remove('is-loading');
      setTimeout(() => { if (btn.isConnected && btn.textContent !== label) { btn.textContent = label; btn.classList.remove('is-added'); btn.disabled = false; } }, 2200);
    }
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-lpq-open], a[href="#quiz"], a[href$="#find-my-match"]');
    if (opener) { open(event); return; }
    if (!root.classList.contains('is-open')) return;
    if (event.target.closest('[data-lpq-close]')) { close(); return; }
    if (event.target.closest('[data-lpq-back]')) {
      const steps = visibleSteps();
      if (index > steps.length) index = steps.length;
      index = Math.max(0, (history.pop() ?? index - 1));
      renderStep(-1);
      return;
    }
    if (event.target.closest('[data-lpq-restart]')) { answers = {}; history = []; index = 0; renderStep(-1); return; }
    const add = event.target.closest('[data-lpq-add]');
    if (add) { addToCart(add); return; }
    const opt = event.target.closest('[data-lpq-opt]');
    if (opt) {
      const step = visibleSteps()[index];
      if (step.multi) {
        const list = new Set(answers[step.id] || []);
        list.has(opt.dataset.lpqOpt) ? list.delete(opt.dataset.lpqOpt) : list.add(opt.dataset.lpqOpt);
        answers[step.id] = [...list];
        opt.classList.toggle('is-on');
        opt.setAttribute('aria-pressed', String(list.has(opt.dataset.lpqOpt)));
        body.querySelector('[data-lpq-next]').disabled = list.size === 0;
        return;
      }
      answers[step.id] = opt.dataset.lpqOpt;
      body.querySelectorAll('[data-lpq-opt]').forEach((b) => { b.classList.toggle('is-on', b === opt); b.setAttribute('aria-pressed', String(b === opt)); });
      history.push(index);
      setTimeout(() => { index += 1; renderStep(1); }, 260);
      return;
    }
    if (event.target.closest('[data-lpq-next]')) { history.push(index); index += 1; renderStep(1); }
  });

  document.addEventListener('keydown', (event) => {
    if (!root.classList.contains('is-open')) return;
    if (event.key === 'Escape') { close(); return; }
    if (event.key !== 'Tab') return;
    const f = [...dialog.querySelectorAll('button:not([disabled]):not([hidden]), a[href], select, [tabindex="0"]')].filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    if (event.shiftKey && document.activeElement === f[0]) { event.preventDefault(); f[f.length - 1].focus(); }
    else if (!event.shiftKey && document.activeElement === f[f.length - 1]) { event.preventDefault(); f[0].focus(); }
  });

  if (location.hash === '#quiz') open();
})();
